var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit, Watch } from "vue-property-decorator";
import { Dependencies } from '~/core/decorator';
import { CaseOperatorPageService } from '~/services/domain-service/case-operator-page.service.ts';
import { State, namespace } from "vuex-class";
import { MENU_CHANNEL } from "~/config/enum.config";
var CollectionExecutionModule = namespace('collection-execution');
var ImplementStep = /** @class */ (function (_super) {
    __extends(ImplementStep, _super);
    function ImplementStep() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            legalStatus: "EXECUTE",
            id: "",
            beExecutor: "",
            executeDate: "",
            executeCourtName: "",
            executeNumber: "",
            executeObject: "",
            executeJudgePhone: "",
            assessCompanyName: "",
            assessCompanyPhone: "",
            executeAmount: "",
            assessAmount: "",
            auctionAmount: "",
            carTransactionAmount: "",
            executeRemark: ""
        };
        _this.rules = {
            beExecutor: [{ required: true, message: "请输入被执行人" }],
            executeDate: [{ required: true, message: "请选择执行立案时间" }],
            executeCourtName: [{ required: true, message: "请输入执行立案法院" }],
            executeNumber: [{ required: true, message: "请输入执行案号" }],
            executeObject: [{ required: true, message: "请输入执行标的" }]
        };
        _this.options5 = [];
        _this.submitLoading = false;
        return _this;
    }
    ImplementStep.prototype.nextStepEmit = function () { };
    ImplementStep.prototype.previousStepEmit = function () { };
    ImplementStep.prototype.emitSuccess = function () {
        var _this = this;
        //查询执行立案法院名称去重
        this.caseOperatorPageService
            .queryExecuteCourtName()
            .subscribe(function (data) {
            if (data) {
                _this.options5 = data;
            }
        }, function (err) {
        });
        if (this.id) {
            this.showLegalInfoById(this.id);
        }
        else {
            // this.showLegalInfo();
        }
    };
    ImplementStep.prototype.showPersonalName = function (val) {
        this.formData.beExecutor = val.personalName;
    };
    Object.defineProperty(ImplementStep.prototype, "isShow", {
        get: function () {
            var _this = this;
            var arr = [MENU_CHANNEL.Legal_personal, MENU_CHANNEL.Legal_team, MENU_CHANNEL.Assist_legal];
            if (arr.find(function (v) { return _this.menuChannel === v; })) {
                // 添加催记显示保存按钮 或编辑催记 与该登录用户一致显示
                if (!this.operatorId || this.operatorId === this.userData.id)
                    return true;
                else
                    return false;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    ImplementStep.prototype.mounted = function () {
        var _this = this;
        //查询执行立案法院名称去重
        this.caseOperatorPageService
            .queryExecuteCourtName()
            .subscribe(function (data) {
            if (data) {
                _this.options5 = data;
            }
        }, function (err) {
        });
        if (this.id) {
            this.showLegalInfoById(this.id);
        }
        else {
            this.formData.beExecutor = this.topInfo.personalName;
            // this.showLegalInfo();
        }
    };
    ImplementStep.prototype.showLegalInfoById = function (val) {
        var _this = this;
        this.caseOperatorPageService
            .queryCaseLegalRecordById(val)
            .subscribe(function (data) {
            if (data) {
                _this.formData.id = data.id;
                if (data.isExecute === "YES") {
                    _this.formData.beExecutor = data.beExecutor;
                }
                _this.formData.executeDate = data.executeDate;
                _this.formData.executeCourtName = data.executeCourtName;
                _this.formData.executeNumber = data.executeNumber;
                _this.formData.executeObject = data.executeObject;
                _this.formData.executeJudgePhone = data.executeJudgePhone;
                _this.formData.assessCompanyName = data.assessCompanyName;
                _this.formData.assessCompanyPhone = data.assessCompanyPhone;
                _this.formData.executeAmount = data.executeAmount;
                _this.formData.assessAmount = data.assessAmount;
                _this.formData.auctionAmount = data.auctionAmount;
                _this.formData.carTransactionAmount = data.carTransactionAmount;
                _this.formData.executeRemark = data.executeRemark;
            }
        }, function (err) {
        });
    };
    ImplementStep.prototype.showLegalInfo = function () {
        var _this = this;
        //查询上一条催记是否结案，回显数据
        this.caseOperatorPageService
            .queryUnClossCaseLegalRecord(this.caseId)
            .subscribe(function (data) {
            if (data) {
                _this.formData.id = data.id;
                if (data.isExecute === "YES") {
                    _this.formData.beExecutor = data.beExecutor;
                }
                _this.formData.executeDate = data.executeDate;
                _this.formData.executeCourtName = data.executeCourtName;
                _this.formData.executeNumber = data.executeNumber;
                _this.formData.executeObject = data.executeObject;
                _this.formData.executeJudgePhone = data.executeJudgePhone;
                _this.formData.assessCompanyName = data.assessCompanyName;
                _this.formData.assessCompanyPhone = data.assessCompanyPhone;
                _this.formData.executeAmount = data.executeAmount;
                _this.formData.assessAmount = data.assessAmount;
                _this.formData.auctionAmount = data.auctionAmount;
                _this.formData.carTransactionAmount = data.carTransactionAmount;
                _this.formData.executeRemark = data.executeRemark;
            }
        }, function (err) {
        });
    };
    ImplementStep.prototype.submit = function () {
        var _this = this;
        var form = this.$refs["implemnet-step-form"];
        form.validate(function (valid) {
            if (!valid)
                return false;
            if (_this.menuChannel === MENU_CHANNEL.Assist_legal) {
                _this.formData.assistId = _this.otherData.assistId;
            }
            _this.formData.caseId = _this.caseId;
            if (_this.formData.executeDate)
                _this.formData.executeDate = _this.$filter.dateTimeFormat(_this.formData.executeDate);
            _this.caseOperatorPageService
                .addCaseLegalRecord(_this.formData)
                .subscribe(function (data) {
                form.resetFields();
                _this.formData.id = "";
                _this.emitSuccess();
                _this.$message.success('法催催记执行已添加成功，如需修改请在法务详情中进行修改');
            }, function (err) {
                _this.submitLoading = false;
            });
        });
    };
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], ImplementStep.prototype, "caseOperatorPageService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], ImplementStep.prototype, "caseId", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], ImplementStep.prototype, "menuChannel", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], ImplementStep.prototype, "otherData", void 0);
    __decorate([
        Prop({ type: String, required: false })
    ], ImplementStep.prototype, "id", void 0);
    __decorate([
        Prop()
    ], ImplementStep.prototype, "topInfo", void 0);
    __decorate([
        Prop({ type: String })
    ], ImplementStep.prototype, "operatorId", void 0);
    __decorate([
        State
    ], ImplementStep.prototype, "userData", void 0);
    __decorate([
        Emit('nextStep')
    ], ImplementStep.prototype, "nextStepEmit", null);
    __decorate([
        Emit('previousStep')
    ], ImplementStep.prototype, "previousStepEmit", null);
    __decorate([
        Emit('emitSuccess')
    ], ImplementStep.prototype, "emitSuccess", null);
    __decorate([
        Watch('topInfo')
    ], ImplementStep.prototype, "showPersonalName", null);
    ImplementStep = __decorate([
        Component({
            components: {}
        })
    ], ImplementStep);
    return ImplementStep;
}(Vue));
export default ImplementStep;
